import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '../../store/store'
import { Realm } from '../realm/realmSlice'
import { adminModeInitialState } from './definitions'

export const adminModeSlice = createSlice({
  name: 'adminModeSlice',
  initialState: adminModeInitialState,
  reducers: {
    activateAdminMode: (state, { payload }: PayloadAction<Realm>) => {
      state.value = true
      state.favoriteRealm = payload
    },
    disableAdminMode: (state) => {
      state.value = false
      state.favoriteRealm = 'fic'
    },
  },
})

export const { activateAdminMode, disableAdminMode } = adminModeSlice.actions
export const selectAdminMode = (state: RootState): boolean => state.editor.value
export default adminModeSlice.reducer
